/**
 * 考勤联动视频批量查询（媒体网关）。最后更新：2026-07-01
 */
import axios from 'axios'

const BATCH_MAX = 80

/**
 * 媒体网关基地址
 */
export function getAttendanceMediaBaseUrl() {
  return process.env.VUE_APP_MEDIA_API || 'https://media.yiqiba.xin'
}

function pickVideoPath(data) {
  if (!data) return ''
  return data.url || data.Url || ''
}

/**
 * 单条查询（兼容旧媒体网关）
 */
async function fetchSingleAttendanceVideo(mediaBaseUrl, eventId, schoolId, month) {
  const params = { eventId: String(eventId), schoolId: String(schoolId) }
  if (month) params.month = month
  const res = await axios.get(`${mediaBaseUrl}/api/attendance/video`, {
    params,
    skipGlobalHttpErrorToast: true,
  })
  const body = res.data
  if (!body || body.success !== true) return ''
  return pickVideoPath(body.data)
}

/**
 * 批量查询考勤视频，返回 eventId -> 相对或绝对播放路径
 */
export async function batchCheckAttendanceVideos(eventIds, schoolId, options) {
  const mediaBaseUrl = getAttendanceMediaBaseUrl()
  const month = options && options.month ? String(options.month).trim() : ''
  const uniqueIds = []
  ;(eventIds || []).forEach((id) => {
    const s = id == null ? '' : String(id).trim()
    if (s && !uniqueIds.includes(s)) uniqueIds.push(s)
  })

  if (!uniqueIds.length || !schoolId) return {}

  const result = {}
  for (let i = 0; i < uniqueIds.length; i += BATCH_MAX) {
    const chunk = uniqueIds.slice(i, i + BATCH_MAX)
    let batchOk = false
    try {
      const res = await axios.post(
        `${mediaBaseUrl}/api/attendance/videos/batch`,
        {
          schoolId: String(schoolId),
          month: month || undefined,
          eventIds: chunk,
        },
        { skipGlobalHttpErrorToast: true }
      )
      const body = res.data
      const items = (body && body.data && body.data.items) || (body && body.Data && body.Data.Items) || []
      if (body && body.success === true && Array.isArray(items)) {
        batchOk = true
        items.forEach((item) => {
          const eventId = item && (item.eventId || item.EventId)
          const ok = item && (item.success === true || item.Success === true)
          const url = item && (item.url || item.Url)
          if (eventId && ok && url) {
            result[String(eventId)] = url
          }
        })
      }
    } catch (e) {
      batchOk = false
    }

    if (!batchOk) {
      await Promise.all(chunk.map(async (eventId) => {
        try {
          const url = await fetchSingleAttendanceVideo(mediaBaseUrl, eventId, schoolId, month)
          if (url) result[eventId] = url
        } catch (err) {
          /* 无视频 */
        }
      }))
    }
  }

  return result
}

/**
 * 将批量查询结果写入列表行 hasVideo / videoUrl
 */
export async function applyAttendanceVideosToRows(vm, rows, schoolId, options) {
  const mediaBaseUrl = getAttendanceMediaBaseUrl()
  const eventIds = (rows || []).map((row) => row.Id).filter(Boolean)
  const map = await batchCheckAttendanceVideos(eventIds, schoolId, options)

  ;(rows || []).forEach((row, index) => {
    const eventId = row.Id == null ? '' : String(row.Id)
    const videoPath = map[eventId]
    if (videoPath) {
      const fullUrl = /^https?:\/\//i.test(videoPath) ? videoPath : mediaBaseUrl + videoPath
      vm.$set(rows[index], 'hasVideo', true)
      vm.$set(rows[index], 'videoUrl', fullUrl)
    } else {
      vm.$set(rows[index], 'hasVideo', false)
      vm.$set(rows[index], 'videoUrl', '')
    }
  })
}

/**
 * 从查询日期筛选推导月份后缀 yyyyMM
 */
export function resolveAttendanceVideoMonthFromDate(dateStr) {
  const raw = String(dateStr || '').trim()
  const match = raw.match(/^(\d{4})-(\d{2})/)
  return match ? `${match[1]}${match[2]}` : ''
}
